import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=849c0980"
import script from "./ImageUploadForm.vue?vue&type=script&lang=js"
export * from "./ImageUploadForm.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadForm.vue?vue&type=style&index=0&id=849c0980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports